import { useState } from "react";

export default function VisitPasswordGate({ onUnlock, fill = false, title = "" }) {
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (!pw) return;
    setBusy(true);
    setErr("");
    try {
      await onUnlock(pw);
    } catch (x) {
      setErr(String(x.message || x));
    } finally {
      setBusy(false);
    }
  };
  const box = fill
    ? { position: "absolute", inset: 0 }
    : { position: "relative", width: "100%", paddingBottom: "56.25%" };
  return (
    <div data-testid="visit-password-gate" style={{ ...box, background: "#0b0a09", borderRadius: fill ? 0 : 2 }}>
      <form
        onSubmit={submit}
        style={{ position: "absolute", inset: 0, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 10, padding: 'var(--bx-pad)', color: "#F4F1EB", fontFamily: '"General Sans",ui-sans-serif,-apple-system,sans-serif' }}
      >
        <div style={{ fontSize: 16, fontWeight: 500 }}>{title || "This Virtual Visit is private"}</div>
        <div style={{ fontSize: 13, color: "rgba(244,241,235,0.66)" }}>Enter the password you were given.</div>
        <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
          <input
            type="password"
            autoComplete="current-password"
            aria-label="Visit password"
            value={pw}
            onChange={(e) => setPw(e.target.value)}
            style={{ fontSize: 16, padding: "9px 12px", borderRadius: 6, border: "1px solid rgba(244,241,235,0.2)", background: "rgba(244,241,235,0.06)", color: "#F4F1EB", width: 200 }}
          />
          <button type="submit" disabled={busy || !pw} style={{ fontSize: 14, fontWeight: 500, padding: "9px 14px", borderRadius: 6, border: "none", background: "#D2542B", color: "#fff", cursor: "pointer", opacity: busy ? 0.6 : 1 }}>
            {busy ? "Checking…" : "Open"}
          </button>
        </div>
        {err ? <div role="alert" style={{ fontSize: 13, color: "#F4D9CC" }}>{err}</div> : null}
      </form>
    </div>
  );
}
